import { Injectable } from '@angular/core'
import { AuthService } from '@spartacus/core'
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject } from 'rxjs'
import { Item } from './cart-item/cart-item.component'
import { take } from 'rxjs/operators'
import { CommonService } from '../../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartService {
  data: any

  private isCheckAvailabilitySource = new BehaviorSubject<[]>([])
  isCheckAvailability$ = this.isCheckAvailabilitySource.asObservable()

  private isShippingTypePartialSource = new BehaviorSubject<boolean>(false)
  isShippingTypePartial$ = this.isShippingTypePartialSource.asObservable()

  private isConsolidatedShipmentSource = new BehaviorSubject<boolean>(false)
  isConsolidatedShipment$ = this.isConsolidatedShipmentSource.asObservable()

  private consCartEntryErrorSource = new BehaviorSubject<[]>([])
  consCartEntryError$ = this.consCartEntryErrorSource.asObservable()

  private deliveryGrpCartEntryErrorSource = new BehaviorSubject<any>({})
  deliveryGrpCartEntryError$ =
    this.deliveryGrpCartEntryErrorSource.asObservable()

  private defaultCartHeaderDateSource = new BehaviorSubject<any>('')
  defaultCartHeaderDate$ = this.defaultCartHeaderDateSource.asObservable()

  private proceedClickedData = new BehaviorSubject<boolean>(null)
  getClicked = this.proceedClickedData.asObservable()

  private soldToSelectedData = new BehaviorSubject<boolean>(null)
  getSelectedSoldTo = this.soldToSelectedData.asObservable()

  constructor(
    public commonService: CommonService,
    private auth: AuthService,
    private http: HttpClient
  ) {}

  deleteProduct(userType, cartId, entryNumber) {
    const urlParam = [
      'users',
      userType,
      'carts',
      cartId,
      'entries',
      entryNumber,
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.deleteData(apiUrl)
  }

  deleteCart(userType, cartId) {
    const urlParam = ['users', userType, 'carts', cartId]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.deleteData(apiUrl)
  }

  deleteMultipleCartEntries(userType, cartId, data) {
    const urlParam = [
      'users',
      userType,
      'carts',
      cartId,
      'cartEntries',
      'deleteEntries',
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.deleteMultipleEntries(apiUrl, { body: data })
  }

  getOrderType(userType) {
    let url
    let urlParam = []
    urlParam = ['users', userType, 'rfqcart', 'orderType']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url)
  }

  exportCart(userType, cartId) {
    const urlParam = ['users', userType, 'carts', cartId, 'export']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData_Excel(apiUrl)
  }

  exportBuyCart(userType, cartId) {
    const urlParam = ['users', userType, cartId, 'exportSavedCarts']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData_Excel(apiUrl)
  }

  exportQuoteCart(userType, cartId) {
    const urlParam = [
      'users',
      userType,
      'quote',
      cartId,
      `export?savedCart=true`,
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData_Excel(apiUrl)
  }

  getLegalEntity(userType) {
    let url
    let urlParam = []
    urlParam = ['users', userType, 'rfqcart', 'legalEntity']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url)
  }

  getCheckAvailability(item: Item, cartId, userType, selectedPlant) {
    const apiParams = {
      product: {
        code: item.product.code,
      },
      quantity: item.quantity,
      customerRequestedDate: item.assignedShipDate,
      entryNumber: item.entryNumber,
      selectedPlant: selectedPlant,
    }
    const urlParam = [
      'users',
      userType,
      'carts',
      cartId,
      'entries',
      item.entryNumber,
      'checkAvailbility',
    ]
    const url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, apiParams)
  }
  getMultipleCheckAvailability(item, cartId, userType) {
    const urlParam = [
      'users',
      userType,
      'carts',
      cartId,
      'entries',
      'checkAvailbilityEntries',
    ]
    const url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, item)
  }

  setCheckAvailabilityFlag(item, addItemFLag) {
    this.isCheckAvailabilitySource.pipe(take(1)).subscribe((res: any) => {
      if (item.length <= 0) {
        return this.isCheckAvailabilitySource.next([])
      }
      if (addItemFLag) {
        res.push(item)
        res = res.filter(
          (element, index, array) =>
            index ===
            array.findIndex(
              (el) =>
                el.product.code === element.product.code &&
                el.entryNumber == element.entryNumber
            )
        )
        this.isCheckAvailabilitySource.next(res)
      } else {
        res = res.filter((element, index) => {
          return element.product.code != item.product.code
        })
        this.isCheckAvailabilitySource.next(res)
      }
    })
  }

  setShippingType(type) {
    this.isShippingTypePartialSource.next(type)
  }

  setConsolidatedShipment(type) {
    this.isConsolidatedShipmentSource.next(type)
  }

  setConsErrors(itemsArray) {
    this.consCartEntryErrorSource.next(itemsArray)
  }

  setDeliveryGroupErrors(errorsObj: any) {
    this.deliveryGrpCartEntryErrorSource.next(errorsObj)
  }

  setCartHeaderDate(defDate?: any) {
    this.defaultCartHeaderDateSource.next(defDate)
  }

  changeRequestShipDate(shipDate, userType, cartId) {
    const apiParams = {
      customerRequestedDate: shipDate,
    }
    const urlParam = ['users', userType, 'carts', cartId, 'updateAllShipDate']
    const url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, apiParams)
  }

  sendOrderType(userType, cartId, orderType) {
    let url
    let urlParam = []
    urlParam = ['users', userType, 'vscart', cartId, orderType]
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, null)
  }

  convertToQuoteCart(userType, cartId, entries) {
    let url
    let urlParam = []
    const apiParams = {
      orderEntries: entries,
    }
    urlParam = ['users', userType, 'carts', cartId, 'quoteCart', 'create']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, apiParams)
  }
  changeShippingType(userType, cartId, consType, type) {
    let url
    let urlParam = []
    const apiParams = {
      shippingType: type,
    }
    urlParam = ['users', userType, 'carts', cartId, 'proceedToCheckout']
    if (type) {
      url =
        this.commonService.constructUrl(urlParam) + '?shippingType=' + consType
    } else {
      url =
        this.commonService.constructUrl(urlParam) +
        '?isConsolidatedShiment=' +
        consType
    }
    // url = this.commonService.constructUrl(urlParam) + '?shippingType=' + type + '&isConsolidatedShiment=' + consType;
    return this.commonService.postData(url, null)
  }

  validateDeliveryGroups(cartEntries) {
    let deliveryGroupErrors = {
      type: '',
      entryNumbers: [],
    }

    for (const entry of cartEntries) {
      if (!entry.deliveryGroupNumber) {
        deliveryGroupErrors.type = '101'
        deliveryGroupErrors.entryNumbers.push(entry.entryNumber)
        return deliveryGroupErrors
      }

      if (!entry.assignedShipDate) {
        deliveryGroupErrors.type = '102'
        deliveryGroupErrors.entryNumbers.push(entry.entryNumber)
        return deliveryGroupErrors
      }

      deliveryGroupErrors = this.checkPromisedShipDateMismatch(
        cartEntries,
        entry
      )
      if (deliveryGroupErrors.type) {
        deliveryGroupErrors.entryNumbers.push(entry.entryNumber)
        return deliveryGroupErrors
      }

      deliveryGroupErrors = this.checkLegalEntityMismatch(cartEntries, entry)
      if (deliveryGroupErrors.type) {
        deliveryGroupErrors.entryNumbers.push(entry.entryNumber)
        return deliveryGroupErrors
      }
    }
  }

  checkLegalEntityMismatch(cartEntries, item): any {
    const error = {
      type: '',
      entryNumbers: [],
    }
    for (const entry of cartEntries) {
      if (
        entry.deliveryGroupNumber == item.deliveryGroupNumber &&
        entry.selectedLegalEntity.uid != item.selectedLegalEntity.uid
      ) {
        error.type = '104'
        error.entryNumbers.push(entry.entryNumber)
      }
    }
    return error
  }

  checkPromisedShipDateMismatch(cartEntries, item): any {
    const error = {
      type: '',
      entryNumbers: [],
    }
    for (const entry of cartEntries) {
      if (
        entry.deliveryGroupNumber == item.deliveryGroupNumber &&
        entry.assignedShipDate != item.assignedShipDate
      ) {
        error.type = '103'
        error.entryNumbers.push(entry.entryNumber)
      }
    }
    return error
  }

  splitCartEntry(userType, cartId, entryNumber): any {
    let url
    let urlParam = []
    urlParam = [
      'users',
      userType,
      'carts',
      cartId,
      'entries',
      entryNumber,
      'splitByAvailbility',
    ]
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, {})
  }

  splitItemEntry(userType, cartId, entryNumber): any {
    let url
    let urlParam = []
    urlParam = [
      'users',
      userType,
      'carts',
      cartId,
      'entries',
      entryNumber,
      'splitEntry',
    ]
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, {})
  }

  addDeliveryGroups(userType, cartId, cartData): any {
    let url
    let urlParam = []
    const apiParams = cartData
    urlParam = ['users', userType, 'carts', cartId, 'deliveryGroup', 'add']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, apiParams)
  }

  populateQuoteConvertRequest(items): Item[] {
    const selectedItems: Item[] = []
    items.forEach((item) => {
      /* const i = {
        brand: item.product.categories[0].code || '',
        customerRequestedDate: item.customerRequestedDate,
        partDescription: item.product.name || '',
        partNumber: item.product.code || '',
        productType: 'Part',
        quantity: item.quantity || 1,
      }; */
      selectedItems.push(item)
    })
    return selectedItems
  }

  addCartItemComments(userType, cartId, entryNumber, commentText): any {
    // /{baseSiteId}/users/{userId}/cart/{cartId}/entries/{entryNumber}/updateComment
    let url
    let urlParam = []
    const apiParams = {
      comment: commentText,
    }
    urlParam = [
      'users',
      userType,
      'carts',
      cartId,
      'entries',
      entryNumber,
      'updateComment',
    ]
    url = this.commonService.constructUrl(urlParam)
    /* const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json'); */
    return this.commonService.postData(url, apiParams)
  }

  updateMaterialNumber(userType, cartId, entryNumber, materialNum): any {
    let url
    let urlParam = []
    const apiParams = {
      customerMaterialNumber: materialNum,
    }
    urlParam = [
      'users',
      userType,
      'carts',
      cartId,
      'entries',
      entryNumber,
      'updateMaterialNumber',
    ]

    url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, apiParams)
  }

  updateCustomerReqDate(userType, cartId, entryNumber, customerRequestedDate): any {
    let url
    let urlParam = []
    const apiParams = {
      customerRequestedDate: customerRequestedDate,
    }
    urlParam = [
      'users',
      userType,
      'carts',
      cartId,
      'entries',
      entryNumber,
      'updateMaterialNumber',
    ]

    url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, apiParams)
  }

  applyCoupons(userType, cartId, coupon): any {
    // /{baseSiteId}/users/{userId}/carts/{cartId}/vouchers?voucherId=VSTEST
    let url
    let urlParam = []
    urlParam = ['users', userType, 'carts', cartId, 'vouchers']
    url = this.commonService.constructUrl(urlParam) + '?voucherId=' + coupon
    return this.commonService.postData(url, {})
  }

  removeCoupon(userType, cartId, coupon): any {
    let url
    let urlParam = []
    urlParam = ['users', userType, 'carts', cartId, 'vouchers', coupon]
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.deleteData(url)
  }

  checkPrice(product) {
    const urlParams = ['products', 'productCode']
    let lastPart = `checkPrice?`
    lastPart += `productCode=${encodeURIComponent(product.code)}`
    urlParams.push(lastPart)
    const apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.getData_WithoutRetry(apiUrl)
  }

  saveOrderSalesCommission(cartId, salesOrderCommmission) {
    let urlParams = [
      'users',
      'current',
      'carts',
      cartId,
      'saveOrderSalesCommission',
    ]
    const apiUrl =
      this.commonService.constructUrl(urlParams) +
      '?isSalesOrderCommission=' +
      salesOrderCommmission
    return this.commonService.postData(apiUrl, {})
  }

  acknowledgeNonSellProducts(cartId) {
    const urlParams = [
      'users',
      'current',
      'carts',
      cartId,
      'removeNonSellableProducts',
    ]
    const apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.deleteData(apiUrl)
  }
  getSoldToAddress() {
    const urlParams = ['users', 'current', 'vscart', 'getSoldToAddresses']
    const apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.getData(apiUrl)
  }
  saveSalesCommissionUnit(checkoutCartId, soldToUnitId) {
    const urlParams = [
      'users',
      'current',
      'vscart',
      checkoutCartId,
      'saveSalesCommissionUnit',
    ]

    let apiUrl = this.commonService.constructUrl(urlParams)
    // apiUrl = apiUrl+'&soldToUnitId='+soldToUnitId;
    return this.commonService.postData(apiUrl, null, {
      params: {
        soldToUnitId: soldToUnitId,
      },
    })
  }
  proceedClicked(value) {
    this.proceedClickedData.next(value)
  }
  soldToSelected(value) {
    this.soldToSelectedData.next(value)
  }
  getEligibleMergeEntries(cartId) {
    const urlParams = [
      'users',
      'current',
      'carts',
      cartId,
      'getEligibleMergeEntries',
    ]
    const apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.getData(apiUrl)
  }
  mergeBuyCartEntries(cartId, mergeData) {
    const apiParams = {
      entries: mergeData,
    }
    const urlParam = ['users', 'current', 'carts', cartId, 'merge']
    const url = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(url, apiParams)
  }
}
